<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='11'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <div style="width:100%;padding-top: 5px;">
            <el-button type="primary" size="mini" round plain @click="Createtask()">添加报价</el-button>
            <el-select v-model="listQuery.istransaction" clearable placeholder="是否成交" size="small" style="margin-left: 20px;" @change="changeTransaction">
              <el-option label="否" value="1"></el-option>
              <el-option label="是" value="2"></el-option>
            </el-select>
            <el-input size="small" v-model="SearchGoodData" clearable placeholder="请输入产品名称或SAP代码" style="width: 300px;padding-bottom:4px;margin-left: 20px;" class="filter-item">
              <el-button slot="append" @click="SearchGood">搜索</el-button>
            </el-input>
            <el-select v-if="current_user.id == 2 || current_user.id == 100" v-model="listQuery.user_id" placeholder="用户" clearable @change="changeTransaction" size="small" style="width: 150px;margin-left: 20px;">
              <el-option
                v-for="item in optionsUserList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <div style="float: right;">
              <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="dialogVisible = true"></i>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row style="position: static;">
              <el-col :span="24" class="task">
                <el-table :data="list" v-loading="qyloading" border style="width: 100%" :row-class-name="tableRowClassName">
                  <!-- <el-table-column align="center" prop="id" label="序号" width="50px"></el-table-column> -->
                  <el-table-column align="center" prop="formnumber" label="表单编号" width="77px"></el-table-column>
                  <el-table-column align="center" prop="cusnumber" label="客户编号" width="77px"></el-table-column>
                  <el-table-column align="center" prop="salescons" label="销售顾问" width="77px"></el-table-column>
                  <el-table-column align="center" prop="name" label="采购方-公司名称" width="126px"></el-table-column>
                  <el-table-column align="center" prop="legal_person" label="采购方-联系人姓名" width="140px"></el-table-column>
                  <el-table-column align="center" prop="phone" label="采购方-联系人电话" width="140px"></el-table-column>\
                  <el-table-column align="center" prop="address" label="采购方-公司地址" width="126px"></el-table-column>
                  <el-table-column align="center" prop="demand" label="采购方-客户需求" width="126px"></el-table-column>
                  <el-table-column align="center" label="是否成交" width="110px">
                    <template slot-scope="{row}">
                      <el-switch
                        v-model="row.istransaction"
                        active-value="2"
                        active-text="是"
                        active-color="#13ce66"
                        inactive-text="否"
                        inactive-value="1"
                        inactive-color="#ff4949"
                        @change="changeTransactionState(row, 'istransaction')"
                      >
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="addtime" label="报价日期"></el-table-column>
                  <el-table-column label="操作" align="center"  fixed="right" width="140px">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-button size="mini" type="text" @click="HandleQuotationsd(scopes.row)">报价单</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                        style="margin-left: 10px;"
                      >
                        <p>确定删除该报价单吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getQuotationList" />
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="报价单编辑" :visible.sync="dialogFormVisible" width="70%" :close-on-click-modal="false">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <div v-loading="qyloading">
          <div class="ant-card">
            <div class="ant-card-head">
              <div class="ant-card-head-wrapper">
                <div class="ant-card-head-title">采购方</div>
              </div>
            </div>
            <el-row>
              <el-col :span="16">
                <el-form-item label="公司名称" prop="name">
                  <el-autocomplete
                    v-model="formData.name"
                    :fetch-suggestions="querySearchCompany"
                    placeholder="请输入公司名称"
                    :title="formData.name"
                    clearable
                    style="width:100%"
                    @select="handleSelectCompany($event)"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系人姓名" prop="legal_person">
                  <el-input v-model="formData.legal_person" placeholder="请输入联系人姓名"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="联系人电话" prop="phone">
                  <el-input v-model="formData.phone" placeholder="请输入联系人电话"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="公司地址" prop="address">
                  <el-input v-model="formData.address" placeholder="请输入公司地址"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户需求">
                  <el-input v-model="formData.demand" placeholder="请输入客户需求"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="ant-card">
            <div class="ant-card-head"><div class="ant-card-head-wrapper"><div class="ant-card-head-title">销售方</div></div></div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="联系人姓名" prop="cname">
                  <el-autocomplete
                    v-model="formData.cname"
                    :fetch-suggestions="querySearchCname"
                    placeholder="请输入联系人姓名"
                    :title="formData.cname"
                    clearable
                    style="width:100%"
                    @select="handleSelectCname($event)"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系人电话" prop="cphone">
                  <el-input v-model="formData.cphone" placeholder="请输入联系人电话"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="表单编号" prop="formnumber">
                  <el-input v-model="formData.formnumber" placeholder="请输入表单编号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="客户编号" prop="cusnumber">
                  <el-input v-model="formData.cusnumber" placeholder="请输入客户编号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="销售顾问" prop="salescons">
                  <el-input v-model="formData.salescons" placeholder="请输入销售顾问"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="报价日期">
                  <el-date-picker
                    v-model="formData.addtime"
                    type="date"
                    placeholder="请选择日期"
                    :clearable="false"
                    style="width:100%"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="ant-card">
            <div class="ant-card-head">
              <div class="ant-card-head-wrapper">
                <div class="ant-card-head-title">购买商品</div>
                <div class="ant-card-head-button">
                <el-button type="primary" icon="el-icon-download" plain style="margin:0px 6px 6px 20px;float:left;" @click="downloadht">报价模板下载</el-button>
                  <el-upload
                    ref="upload"
                    class="upload-demo"
                    :action="upload_url"
                    :on-success="handlesuccess"
                    :before-upload="beforeAvatarUpload"
                    accept=".xls,.xlsx"
                    :file-list="fileList"
                    :headers="requestHeaders"
                    :auto-upload="true"
                    :multiple="false"
                    :limit="1"
                    style="float:left;width: 175px;"
                  >
                    <el-button slot="trigger" type="primary" icon="el-icon-upload2">报价单EXCEl上传</el-button>
                  </el-upload>
                  <el-button v-if="formData.filename" slot="trigger" type="primary" icon="el-icon-download" style="margin:0px 6px 6px 0px;float:left;" @click="DownQuotation(formData.filename)">报价单EXCEl下载</el-button>
                  <el-popover v-model="visible" placement="top" width="200px">
                    <p>确定清空吗？</p>
                    <div style="text-align: right; margin: 0;">
                      <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                      <el-button type="primary" size="mini" @click="ClearGoodsMessage">确定</el-button>
                    </div>
                    <el-button slot="reference" icon="el-icon-delete">清空表单</el-button>
                  </el-popover>
                  <div class="filter-container">
                    <el-input v-model="SearchData" placeholder="请输入序号" style="width: 200px;padding-bottom:4px" class="filter-item" />
                    <el-button class="filter-item" type="primary" icon="el-icon-search" @click="goNum">搜索</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(item,index) in goodsMessage" :key="index" class="ant-card-bottom">
              <el-form :ref="'item'+index" :model="item" :rules="rules" style="padding-bottom: 0;">
                <el-row :class="'goNum_'+item.order_num">
                  <el-col :span="1">
                    <el-form-item label="序号" prop="order_num">
                      <div style="width: 30px;height: 30px;font-size: 15px;">{{ item.order_num }}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" style="margin-left: 10px;">
                    <el-form-item label="货品名称" prop="title">
                      <el-autocomplete
                        v-model="item.title"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入货品名称"
                        :title="item.title"
                        clearable
                        style="width:100%"
                        @select="handleSelect($event, index)"
                      ></el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" style="margin-left: 10px;">
                    <el-form-item label="描述">
                      <el-input v-model="item.model_number" placeholder="请输入描述" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="margin-left: 10px;">
                    <el-form-item label="数量" prop="number">
                      <el-input v-model="item.number" placeholder="请输入数量" min="1" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="margin-left: 10px;">
                    <el-form-item label="单位" prop="units">
                      <el-input v-model="item.units" placeholder="单位" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="margin-left: 10px;">
                    <el-form-item label="品牌">
                      <el-input v-model="item.brand" placeholder="品牌" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" style="margin-left: 10px;">
                    <el-form-item label="含税单价" prop="tax_price">
                      <el-input v-model="item.tax_price" placeholder="含税单价" clearable>
                        <template slot="append">
                          <el-image
                            v-if="item.imgpath"
                            style="width: 20px; height: 20px"
                            :src="item.imgpath"
                            :preview-src-list="item.srcList"
                          >
                          </el-image>
                          <span v-else style="color:#C0C4CC">暂无图片</span>
                        </template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="10" style="margin-left: 65px;">
                    <el-form-item label="货品渠道">
                      <el-input v-model="item.channel" placeholder="请输入货品渠道" clearable>
                        <el-button slot="append" @click="copyText(item.channel)">复制</el-button>
                      </el-input>
                      <el-link v-if="goodsMessage.length > 1" type="primary" @click="delMsg(index)">删除</el-link>&nbsp;
                      <el-link type="primary" @click="addMsg">添加</el-link>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11" style="margin-left: 10px;">
                    <el-form-item label="备注">
                      <el-input v-model="item.remarks" placeholder="请输入备注" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveTemporary()">暂 存</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveQuotation()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="报价列表说明"
      :visible.sync="dialogVisible"
      width="50%">
      <el-carousel :autoplay="false" arrow="always" indicator-position="none" height="700px">
        <el-carousel-item v-for="(item,index) in srcList" :key="index">
          <el-image
            style="width: 100%;"
            :src="item"
            :preview-src-list="srcList">
          </el-image>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/quotation'
import busOrders from '@/api/businessOrders'
import { getToken } from '@/utils/auth'
import apiConfig from '../../../config/api.config.js'
import CountTo from 'vue-count-to'

export default {
  name: 'QuotationList',
  components: { Top, LeftNav, Bottom, Pagination, CountTo },
  data () {
    return {
      api,
      list: [],
      total: 0,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_quotation',
      requestHeaders: {
        'X-Token': getToken()
      },
      qyloading: false,
      fileList: [],
      listQuery: {
        limit: 10,
        order: 'id',
        page: 1,
        sort: 'DESC'
      },
      dialogFormVisible: false,
      locktype: false,
      formData: {
        id: null,
        name: '',
        legal_person: '',
        phone: '',
        address: '',
        demand: '',
        cname: '',
        cphone: '',
        formnumber: '',
        cusnumber: '',
        salescons: '',
        addtime: new Date(),
        filename: '',
        goodsMessage: []
      },
      goodsMessage: [
        {
          title: '',
          order_num: 1,
          model_number: '',
          number: 1,
          units: '',
          brand: '',
          tax_price: '',
          remarks: '',
          channel: '',
          is_import: 1,
          is_delete: 1,
          imgpath: '',
          srcList: [],
          mengniu_code: ''
        }
      ], // 货品信息
      rules: {
        name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        legal_person: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系人电话', trigger: 'blur' }],
        address: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
        demand: [{ required: true, message: '请输入客户需求', trigger: 'blur' }],
        cname: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
        cphone: [{ required: true, message: '请输入联系人电话', trigger: 'blur' }],
        formnumber: [{ required: true, message: '请输入表单编号', trigger: 'blur' }],
        cusnumber: [{ required: true, message: '请输入客户编号', trigger: 'blur' }],
        salescons: [{ required: true, message: '请输入销售顾问', trigger: 'blur' }],
        title: [{ required: true, message: '请输入货品名称', trigger: 'blur' }],
        number: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        units: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        // brand: [{ required: true, message: '请输入品牌', trigger: 'blur' }],
        tax_price: [{ required: true, message: '请输入含税单价', trigger: 'blur' }]
      },
      visible: false,
      SearchData: '',
      dialogVisible: false,
      srcList: [
        'https://serv.nmzp.com/uploads/1/image/20240410/b14301d5087476943451ff7461320490.png',
        'https://serv.nmzp.com/uploads/1/image/20240410/e0d32570fcbcb9eadf2f5e3cd0d16f6e.png'
      ],
      SearchGoodData: '',
      optionsUserList: []
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.getQuotationList()
    this.getUserList()
  },
  methods: {
    addMsg (index) {
      // if (this.goodsMessage.length + 1 > 10) {
      //   return
      // }
      var num = this.goodsMessage.length - 1
      this.goodsMessage.push({
        title: '',
        order_num: this.goodsMessage[num].order_num + 1,
        model_number: '',
        number: 1,
        units: '',
        brand: '',
        tax_price: '',
        remarks: '',
        channel: '',
        is_import: 1,
        is_delete: 1,
        imgpath: '',
        srcList: [],
        mengniu_code: ''
      })
    },
    delMsg (index) {
      var numold = this.goodsMessage[0].order_num
      this.goodsMessage.splice(index, 1)
      var numnew = this.goodsMessage[0].order_num
      // 重新排序
      for (var i = index; i < this.goodsMessage.length; i++) {
        if (index === 0) {
          this.goodsMessage[i].order_num = i + numold
        } else {
          this.goodsMessage[i].order_num = i + numnew
        }
      }
    },
    Createtask () {
      this.dialogFormVisible = true
      this.formData = {
        id: null,
        name: '',
        legal_person: '',
        phone: '',
        address: '',
        demand: '',
        cname: '',
        cphone: '',
        formnumber: '',
        cusnumber: '',
        salescons: '',
        addtime: new Date(),
        filename: '',
        goodsMessage: []
      }
      this.goodsMessage = [
        {
          title: '',
          order_num: 1,
          model_number: '',
          number: 1,
          units: '',
          brand: '',
          tax_price: '',
          remarks: '',
          channel: '',
          is_import: 1,
          is_delete: 1,
          imgpath: '',
          srcList: [],
          mengniu_code: ''
        }
      ]
      this.fileList = []
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      if (this.SearchGoodData) {
        var formdatas = {
          id: row.id,
          searchGoods: this.SearchGoodData
        }
      } else {
        formdatas = {
          id: row.id
        }
      }
      api.getQuotation(formdatas).then(response => {
        this.formData = response.items
        if (this.formData.goodsMessage.length > 0) {
          this.goodsMessage = this.formData.goodsMessage
        }
      })
    },
    handlesuccess (response, file) {
      this.subloading = false
      if (response.code === 20000) {
        this.goodsMessage = response.items
        this.formData.filename = response.message
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      this.subloading = true
      return (extension || extension2) && isLt2M
    },
    getQuotationList () {
      this.qyloading = true
      if (this.current_user.id === 2 || this.current_user.id === 100 || this.current_user.id === 69) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.listQuery.user_id = this.current_user.id
      }
      api.getQuotationList(this.listQuery).then(response => {
        this.list = response.data.items
        this.total = response.data.total
        this.qyloading = false
      })
    },
    handleDelete (row, index, scopes) {
      api.handleDelete({ id: row.id }).then(response => {
        this.getQuotationList()
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
      })
    },
    HandleQuotationsd (row) {
      window.open('https://www.nmzp.com/#/Quotationsd?id=' + row.id, '_blank')
    },
    querySearchCompany (queryString, cb) {
      let results = []
      if (queryString === '') {
        this.restaurant = [{ value: '暂无匹配信息' }]
        cb(this.restaurant)
      } else {
        api.getCompany({ 'search': queryString }).then(response => {
          this.restaurant = response.data
          // const findout = this.restaurants.filter((x) => this.nameFilter(x, queryString))
          results = this.restaurant.map(x => ({ ...x, value: x.name }))
          if (results.length > 0) {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
              cb(results)
            }, 1000 * Math.random())
          } else {
            const nodata = [{ value: '暂无匹配信息' }]
            cb(nodata)
          }
        })
      }
    },
    handleSelectCompany (item) {
      this.formData.name = item.name
      this.formData.legal_person = item.principal
      this.formData.phone = item.phone
      this.formData.address = item.province + item.city + item.district
    },
    querySearchCname (queryString, cb) {
      let results = []
      if (queryString === '') {
        this.restaurant = [{ value: '暂无匹配信息' }]
        cb(this.restaurant)
      } else {
        api.searchMember({ 'search': queryString }).then(response => {
          this.restaurant = response.items
          // const findout = this.restaurants.filter((x) => this.nameFilter(x, queryString))
          results = this.restaurant.map(x => ({ ...x, value: x.name }))
          if (results.length > 0) {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
              cb(results)
            }, 1000 * Math.random())
          } else {
            const nodata = [{ value: '暂无匹配信息' }]
            cb(nodata)
          }
        })
      }
    },
    handleSelectCname (item) {
      this.formData.cname = item.name
      this.formData.cphone = item.tel
    },
    querySearchAsync (queryString, cb) {
      let results = []
      if (queryString === '') {
        this.restaurants = [{ value: '暂无匹配信息' }]
        cb(this.restaurants)
      } else {
        api.searchGoods({ 'search': queryString }).then(response => {
          this.restaurants = response.items
          // const findout = this.restaurants.filter((x) => this.nameFilter(x, queryString))
          results = this.restaurants.map(x => ({ ...x, value: x.title }))
          if (results.length > 0) {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
              cb(results)
            }, 1000 * Math.random())
          } else {
            const nodata = [{ value: '暂无匹配信息' }]
            cb(nodata)
          }
        })
      }
    },
    handleSelect (item, index) {
      this.goodsMessage[index].title = item.title
      this.goodsMessage[index].model_number = item.model_number
      this.goodsMessage[index].units = item.units
      this.goodsMessage[index].brand = item.brand_title
      this.goodsMessage[index].tax_price = item.tax_price
      this.goodsMessage[index].imgpath = item.imgpath.split(',')[0]
      this.goodsMessage[index].srcList = item.imgpath.split(',')
      this.goodsMessage[index].mengniu_code = item.mengniu_code
      this.goodsMessage[index].channel = item.source_sites
    },
    downloadht () {
      window.open('https://serv.nmzp.com/uploads/doexcel/NMZPQUO.xlsx')
    },
    DownQuotation (e) {
      window.open(e)
    },
    ClearGoodsMessage () {
      this.goodsMessage = [
        {
          title: '',
          order_num: 1,
          model_number: '',
          number: 1,
          units: '',
          brand: '',
          tax_price: '',
          remarks: '',
          channel: '',
          is_import: 1,
          is_delete: 1,
          imgpath: '',
          srcList: [],
          mengniu_code: ''
        }
      ]
      this.visible = false
    },
    goNum () {
      var goNum = this.$el.querySelector('.goNum_' + this.SearchData)
      if (goNum) {
        this.$el.querySelector('.goNum_' + this.SearchData).scrollIntoView({ block: 'start', behavior: 'smooth' })
        document.getElementsByClassName('goNum_' + this.SearchData)[0].classList.add('highlight')
        setTimeout(() => {
          document.getElementsByClassName('goNum_' + this.SearchData)[0].classList.remove('highlight')
        }, 5000)
      }
    },
    saveQuotation () {
      const This = this
      this.goodsMessage.forEach((item, index) => {
        // 有多个输入框需校验，待都校验成功后再进行别的操作，所以需要使用Promise
        // 划重点：This.$refs['item'+index][0]
        This.$refs['item' + index][0].validate((valid) => {
          if (valid) {
          }
        })
      })
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            // return false
          }
          this.locktype = true
          this.formData.goodsMessage = this.goodsMessage
          this.formData.user_id = this.current_user.id
          this.formData.temporary_type = '1'
          api.saveQuotation(this.formData).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.getQuotationList()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    saveTemporary () {
      this.locktype = true
      this.formData.goodsMessage = this.goodsMessage
      this.formData.user_id = this.current_user.id
      this.formData.temporary_type = '2'
      api.saveQuotation(this.formData).then(response => {
        this.dialogFormVisible = false
        this.locktype = false
        this.getQuotationList()
        this.$notify({
          title: '成功',
          message: response.message,
          type: 'success'
        })
      })
    },
    changeTransaction () {
      this.getQuotationList()
    },
    changeTransactionState (row, fieldName) {
      const params = { id: row.id }
      params[fieldName] = row[fieldName]
      api.changeIstransaction(params).then(res => {
        if (res.code === 20000) {
          this.$message({ message: '操作成功', type: 'success' })
        } else {
          this.$message({ message: '操作失败', type: 'error' })
        }
      })
    },
    SearchGood () {
      if (this.SearchGoodData) {
        this.listQuery.searchGoods = this.SearchGoodData
        this.getQuotationList()
      } else {
        this.$delete(this.listQuery, 'searchGoods')
        this.getQuotationList()
      }
    },
    getUserList () {
      busOrders.getUserList({MAccountRole: '1, 5'}).then(response => {
        this.optionsUserList = response.data
      })
    },
    copyText (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      try {
        // 尝试执行复制操作
        const success = document.execCommand('copy')
        if (success) {
          this.$message({ message: '复制成功', type: 'success' })
        } else {
          this.$message({ message: '复制失败', type: 'error' })
        }
      } catch (error) {
        this.$message({ message: error, type: 'error' })
      }
      document.body.removeChild(textarea)
    },
    tableRowClassName ({row, rowIndex}) {
      if (row.temporary_type === '2') {
        return 'temporary-row'
      }
      return ''
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 25px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 86%;
}
.ant-card-head {
  min-height: 48px;
  margin-bottom: 40px;
  padding: 0 24px;
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  background: 0 0;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
  background: #f8faff;
}
.ant-card-head-title {
  color: #1890ff;
  padding-top: 10px;
  float: left;
}
.ant-card-head-button {
  width: 90%;
  padding-top: 5px;
  float: left;
}
.filter-container {
  text-align: right;
  display: inline-block;
  float: right;
}
.highlight{
  background-color: #f0f0f0;
}
.el-popper{
  width:600px !important;
}
.ant-card-bottom{
  border-bottom: 2px solid #f0f0f0;
}
</style>
<style>
.el-table .temporary-row {
  background: oldlace;
}
</style>



// WEBPACK FOOTER //
// src/view/member/quotation_list.vue